import React, { Component } from 'react'
import { post, getImg } from '../../service/index'
import { connect } from 'react-redux'
import { Select } from '../Regular/index'

class NoChatCard extends Component {

    constructor(props) {
        super(props)

        this.state = {
            title: this.props.title,
            allDoc: [],
            select_department: -1,

            allComment: []
        }
    }

    componentDidMount = async () => {
        try {
            const { token } = this.props.login.user
            const { conference_id } = this.props
            const res = await post('/get_sub_conference', { conference_id }, token)
            const commentData = await post('/get_comment', { sub_conference_id: res.result[0].id }, token)
            this.setState({
                allDoc: res.result.map(el => ({
                    label: el.document_name,
                    value: el.id
                }
                )),
                select_department: res.result[0].id,
                allComment: commentData.result,
                title: res.result[0].document_name,
            });
        } catch (err) {
            console.log(err)
        }
    }

    _onSelect = async value => {
        const { token } = this.props.login.user
        if (value) {
            this.setState({ select_department: value.value })

            try {
                const commentData = await post('/get_comment', { sub_conference_id: value.value }, token)

                this.setState({
                    allComment: commentData.result
                })
            } catch (err) {
                console.log(err)
            }
        } else {
            this.setState({
                select_department: -1,
                allComment: [],
            })
        }

    }

    render() {
        const { allDoc, select_department, allComment, title } = this.state
        return (
            <div>
                <Select
                    options={allDoc}
                    value={select_department}
                    label='วาระการประชุม'
                    onChange={this._onSelect}
                    mode={1}
                />
                <div style={{ maxHeight: 800, overflowY: 'scroll' }} >
                    {
                        allComment.map((el) => {

                            return <div className='card-chat' key={el.comment_id} >
                                <div className='card' style={{ width: '100%' }}>
                                    <CardProfile user_id={el.user_id} name={el.name + ' ' + el.last_name} position={el.department_name} token={this.props.login.user.token} />
                                    <ChatCardDetail title={title} detail={el.comment} />
                                </div>{
                                    el.user_id === this.props.login.user.user_id ? <DeleteBtn onClick={this.handleDelete(el.comment_id)} /> : null
                                }

                            </div>
                        })
                    }
                </div>
            </div>

        )
    }

    handleDelete = comment_id => async () => {
        let obj = {
            comment_id: comment_id,
        }
        try {
            const { token } = this.props.login.user
            const data = await post('/delete_comment', obj, token)
            window.location.reload()
        } catch (err) {
            console.log(err)
        }
    }
}

const mapStateToProps = (state) => ({
    pdf: state.pdf,
    login: state.login,
})


export default connect(mapStateToProps)(NoChatCard)

class CardProfile extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            avatar: null
        }
    }

    componentDidMount = async () => {
        const { user_id, token } = this.props
        console.log(token)
        try {
            const avatar = await getImg('/image/' + user_id + '.png', token)
            this.setState({ avatar })
        } catch (err) {
            console.log(err)
        }
    }



    render() {
        const { user_id, name, position } = this.props
        const { avatar } = this.state
        return <div className='card-profile'>
            <img src={avatar ? avatar : 'https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png'} className='meeting-profile-image' />
            <span className='name-position' >
                <p> {name} </p>
                <p> {position} </p>
            </span>

        </div>
    }

}

const ChatCardDetail = ({ title, detail }) => {
    return <div className='card-detail' >
        <p className='card-chat-title' > {title} </p>
        <p className='card-chat-detail' >ข้อความ: {detail} </p>
    </div>
}

const DeleteBtn = ({ onClick }) => {
    return <span className='delete-btn' onClick={onClick} >
        <img src={require('../../assets/icon/delete.png')} className='delete-icon' />
    </span>
}


// WEBPACK FOOTER //
// ./src/components/Chat/NoChatCard.js